'use client';

import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { cn } from '../../utils/tailwind';
const Tabs = TabsPrimitive.Root;
const TabsList = React.forwardRef<React.ElementRef<typeof TabsPrimitive.List>, React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>>(({
  className,
  ...props
}, ref) => <TabsPrimitive.List ref={ref} className={cn('flex flex-col rounded-[12px] bg-muted text-muted-foreground gap-1 w-full', className)} {...props} />);
TabsList.displayName = TabsPrimitive.List.displayName;
const TabsTrigger = React.forwardRef<React.ElementRef<typeof TabsPrimitive.Trigger>, React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>>(({
  className,
  children,
  ...props
}, ref) => <TabsPrimitive.Trigger ref={ref} className={cn('flex-1', 'ml-2', 'text-body-1', 'font-semibold', 'relative', 'w-auto', 'py-[10px]', 'inline-flex', 'items-center', 'justify-start', 'whitespace-nowrap', 'px-3', 'text-sm', 'transition-all', 'rounded-[6px]', 'text-gray-600', 'hover:bg-gray-200', 'focus-visible:outline-none', 'disabled:pointer-events-none', 'disabled:opacity-50', 'data-[state=active]:text-primary', className)} {...props}>
    {children}
  </TabsPrimitive.Trigger>);
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;
const TabsContent = React.forwardRef<React.ElementRef<typeof TabsPrimitive.Content>, React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>>(({
  className,
  ...props
}, ref) => <TabsPrimitive.Content ref={ref} className={cn('mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2', className)} {...props} />);
TabsContent.displayName = TabsPrimitive.Content.displayName;
export { Tabs, TabsList, TabsTrigger, TabsContent };